<template>
	<div class="content-box">
		<div v-if="notfound" class="alert alert-info">
			{{ t.error.notfound_content_list }}
		</div>
		<table class="table table-padded" v-if="!notfound">
			<thead>
			<tr>
				<th>
					{{ t.betting.title.status }}
				</th>
				<th>
					{{ t.betting.title.date }}
				</th>
				<th class="text-right">
					{{ t.transactions.amount }}
				</th>
				<th class="text-right">

				</th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="transaction in transactions">
				<td class="nowrap">
					<template v-if="transaction.status == 'Pending'">
						<span class="status-pill blue smaller"></span><span>{{ t.transactions.status.pending }}</span>
					</template>
					<template v-if="transaction.status == 'Processed'">
						<span class="status-pill yellow smaller"></span><span>{{ t.transactions.status.payed }}</span>
					</template>
					<template v-if="transaction.status == 'Faıled'">
						<span class="status-pill red smaller"></span><span>{{ t.transactions.status.failed }}</span>
					</template>
				</td>
				<td class="text-left">
					{{ transaction.addedAt | moment('D MMM ddd', session.timezone) | slimiter(10) }}
					<span class="smaller lighter">
						{{ transaction.addedAt | moment('HH:MM', session.timezone) | slimiter(10) }}
					</span>
				</td>
				<td class="text-right bolder nowrap">
					<span class="text-danger">{{ transaction.amount | toMoney(transaction.currency) }}</span>
				</td>
				<td class="text-right bolder nowrap">
					<span>{{ transaction.info }}</span>
				</td>
			</tr>
			</tbody>
		</table>
		<paginate v-if="pagination" class="mx-3"
		          :page-count="pagination.pageCount"
		          :page-range="pagination.pageRange"
		          :force-page="(pagination.current-1)"
		          :initialPage="(pagination.current-1)"
		          :margin-pages="2"
		          :click-handler="onChangePage"
		          :prev-text="t.previous"
		          :next-text="t.next"
		          :container-class="'pagination float-right'"
		          :page-class="'page-item'"
		          :page-link-class="'page-link'"
		          :prev-class="'page-item'"
		          :prev-link-class="'page-link'"
		          :next-class="'page-item'"
		          :next-link-class="'page-link'"
		>
		</paginate>
	</div>
</template>

<script>

    import Paginate from 'vuejs-paginate'
    export default {
        name: 'transactionWithdraw',
	    components: { Paginate },
        data () {
            return {
                session: session,
                pagination: null,
                t: this.$root.t,
                notfound: false,
	            transactions: null,
	            type: [9,10,17]
            }
        },
        watch: {
            '$route' () {
                this.fetchTransactions();
            },
        },
	    mounted () {

            this.fetchTransactions();
	    },
	    methods: {
            onChangePage (page) {
                this.pagination.current = page;
                this.$router.push({ query: {page: page} });


                window.scroll(0, 0);
            },
            fetchTransactions () {
                this.$bus.$emit('globalLoader', 1);
                this.$http.get(api+'api/v1/user/transactions', {params:  {type: [9,10,16,32], onlyOrder: 1, status: this.$route.query.status, page: this.$route.query.page }})
                    .then(response => {

                        this.pagination = response.body.result.pagination;

                        this.transactions = response.body.result.transactions;
                        this.$bus.$emit('globalLoader', 0);
                        this.notfound = false;
                    }, response => {
                        this.notfound = true;
                        this.$bus.$emit('globalLoader', 0);
                    })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/transactions/transactionWithdraw.vue